import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import NewUserPopup from './new-user-popup/new-user-popup';
import AvgSessionPopup from './avg-session-popup/avg-session-popup';
import { numberFormat, numberFormatWithTextSuffix } from '@/helpers/number-format';
import { sessionService } from '@/providers/services/auth/session';
import GuestUserPop from '@/components/guest-user-pop/guest-user-pop';
import { UsersData } from '@/models/groups/users';
import { SubjectModel } from '@/models/drill-down/subject';
import { DrillDownModel } from '@/models/drill-down/drill-down';

@Component({
    name: 'network-user-card',
    components: {
        'material-icon': GoogleMaterialIcon,
        'new-user-popup': NewUserPopup,
        'avg-session-popup': AvgSessionPopup,
        'guest-popup': GuestUserPop,
    },
})

export default class NetworkUserCard extends Vue {

    public get userCountItem() {
        return !this.disableUserPullup ? this.data : 0;
    }


    /**
     * Checking is tenant user are not
     */
    get isSuperUser() {
        const access = this.$access;
        return access.hasPermission(access.menus.all, access.ACL.all);
    }

    private get isGuestUser() {
        return this.$access.isGuestUser('guest', 'guest');
    }

    private get disableUserPullup() {
        return this.groupType === 'class';
    }

    @Prop()
    public isTenant!: boolean;

    // ---------------------------------------------------------------------------
    // Properties
    @Prop()
    private data!: string;

    @Prop()
    private comparativeGain!: {gain: number; percent: number; across: string};

    @Prop()
    private label!: string;

    @Prop()
    private unit!: string;

    @Prop({ default: false })
    private isLoading!: boolean;

    @Prop()
    private isDemoTenant!: boolean;

    @Prop()
    private lastMonth!: string;

    @Prop()
    private currentMonth!: string;

    @Prop()
    private activeYear!: string;

    @Prop()
    private groupLabel!: string;

    private isGuestPullup: boolean = false;

    private isShowPopup: boolean = false;

    @Prop()
    private usersDrillDownData!: UsersData;

    @Prop()
    private groupType!: string;

    @Prop({default: false})
    private isRestrictClass!: boolean;

    @Prop()
    private isAtInitialLevel!: boolean;

    @Prop()
    private subjectList!: SubjectModel[];

    private activeSubject: SubjectModel | any = null;

    private selectedLevel?: DrillDownModel;

    @Prop()
    private isUserCard!: boolean;


    @Watch('subjectList')
    private onChangeSubject(value: any) {
        this.activeSubject = value.length ? value[0] : null;
    }


    private get isDisableCard() {
        return !this.isTenant || (!this.isDemoTenant && !this.isGuestUser && !this.isUserCard);
    }


    // -----------------------------------------------------------------------------
    // Actions

    private onGoUpward() {
        this.$emit('onGoUpward');
    }

    // -----------------------------------------------------------------------------
    // Method

    private numberFormat(value: number) {
        return numberFormat(value);
    }

    private isLowPercent(value: string = '0') {
        const percent = parseFloat(value) / 100.0;
        return Math.sign(percent);
    }

    private onShowPopup() {
        if (this.isGuestUser) {
            this.isGuestPullup = true;
            return;
        }
        if (this.label === 'New Users' && !this.disableUserPullup) {
        this.isShowPopup = true;
       }

    }

    private onSelectLevel(level: any, subject: any, pullUp: any) {
        this.selectedLevel = level;
        this.$emit('onSelectLevel', level);
    }

    private onSelectSubject(subject: any) {
        this.activeSubject = subject;
        this.$emit('onSelectLevel', this.selectedLevel);
    }

    private onCloseTsPullup() {
        this.isShowPopup = false;
        this.isGuestPullup = false;
    }
}
